import { render, staticRenderFns } from "./FamilyFieldsStep.vue?vue&type=template&id=3ecf1fb8&"
import script from "./FamilyFieldsStep.vue?vue&type=script&lang=js&"
export * from "./FamilyFieldsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports